import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { updatePlanTypesByCircuitType } from '../../order-request.functions';
import { onSelectedApprover, resetWirelineApprover } from './new-circuit/new-circuit-subscription.reducer';

import { actions } from 'react-redux-form';
import {
    //model
    wirelineUpgradeCircuitModel
    //action
    , setPlanDetails
    , setSubscriptionDetails
    , setVendorDetails
    , setPlanOptions
    , setFormSubmitted
    , setResetLoading
    , setResetApprover
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-upgrade-circuit.settings';

export const upgradeCircuitModelA = wirelineUpgradeCircuitModel;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const defaultState = () => ({
    simOptions: []
    , planOptions: []
    , subscription: {}
    , formSubmitted: false
    , vendorDetails: {
        Currency: ''
    }
    , primaryPlanDetails: { ...planDetailConst }
    , isResetLoading: false
    , isResetApprover: false
});

const initialState = defaultState();


export const wirelineUpgradeCircuitActions = {

    onSubscriptionSelect: (value, propsName, objects) => async (dispatch, state) => {

        const { wirelineUpgradeCircuitFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        if (value === '' || value === undefined || !propsName) {
            resetWirelineUpgradeCircuitModel(dispatch);
            resetWirelineUpgradeCircuitForm(dispatch);
            dispatch(resetWirelineApprover());    
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && obj.CircuitId != wirelineUpgradeCircuitFormA.circuitId) {
                    resetWirelineUpgradeCircuitForm(dispatch);
                    resetWirelineUpgradeCircuitModel(dispatch);
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitCode', value));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitId', obj.CircuitId));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.vendorDetailId', obj.VendorDetailId));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.newPlanId', ''));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.planName', ''));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', []));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.planComponentList', []));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.employeeName', ''));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.wireLineApproverId', 0));  
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.businessJustification', ''));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.additionalInformation', ''));
                    dispatch(actions.reset('wirelineUpgradeCircuitFormA.employeeName'));
                    dispatch(actions.reset('wirelineUpgradeCircuitFormA.wireLineApproverId'));
                    dispatch(onSelectedApprover(''))
                    dispatch({ type: setResetApprover, data: true });
                    dispatch({ type: setSubscriptionDetails, data: obj });

                    let vendor = await getVendorDetails(dispatch, obj);

                    if (vendor) {
                        updatePlanTypesByCircuitType(dispatch, setPlanOptions, vendor.VendorDetailId, obj.CircuitTypeId);
                    }
                }
            }
        }
    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch({ type: setPlanDetails, data: planDetailConst });
        await getPlanDetails(dispatch, value);

    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineUpgradeCircuitFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineUpgradeCircuitFormA.employeeName', ''));
            dispatch(actions.change('wirelineUpgradeCircuitFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''));
            dispatch({ type: setResetApprover, data: true });
        } else {
            const obj = objects?.find(o => o[propsName] === value);

            if (obj != null) {
                if (parseInt(obj.EmployeeId) !== parseInt(wirelineUpgradeCircuitFormA.wireLineApproverId)) {
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.employeeName', value));
                    dispatch(actions.change('wirelineUpgradeCircuitFormA.wireLineApproverId', obj.EmployeeId));
                }           
                dispatch(onSelectedApprover(value, obj.EmployeeId));
                setTimeout(function () {
                    dispatch({ type: setResetApprover, data: false });
                }, 5)
            }

        }
    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelineUpgradeCircuitFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest} = state().createRequest;
        const { subscription } = state().wirelineUpgradeCircuitRequest;
        const { requestData, isAmending } = state().requestDetail;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        var data = {
            ...userData
            , RequestTypeId: requestTypeId
            , WirelineUpdatePlanRequest: {
                ...wirelineUpgradeCircuitFormA
                , requestInBehalfId: userData.requestInBehalfId
            },
            ChangeRequestModel: {
                ...userData
                , ...wirelineUpgradeCircuitFormA
                , CircuitId: wirelineUpgradeCircuitFormA.circuitCode ? wirelineUpgradeCircuitFormA.circuitId : 0
                , VendorDetailId: wirelineUpgradeCircuitFormA.vendorDetailId ? wirelineUpgradeCircuitFormA.vendorDetailId : 0
                , RequestTypeId: requestTypeId
                , NoEmail: true
            },
            User: { ...userData },
            IsAmending: isUpdateRequest,
            OrderId: isAmending ? requestData.Order.OrderId : 0,
            CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelineUpgradeCircuitForm: () => (dispatch) => {
        resetWirelineUpgradeCircuitForm(dispatch);
    }
    , resetWirelineUpgradeCircuitModel: () => (dispatch) => {
        resetWirelineUpgradeCircuitModel(dispatch);
    }
    , resetWirelineUpgradeCircuit: (isResetRequestOnBehalf = false) => (dispatch, state) => {
        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }

        resetWirelineUpgradeCircuitForm(dispatch);
        resetWirelineUpgradeCircuitModel(dispatch);
        dispatch(resetWirelineApprover());        
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelineUpgradeCircuitFormA.circuitCode'));
            dispatch(actions.reset('wirelineUpgradeCircuitFormA.circuitId'));
            dispatch(actions.reset('wirelineUpgradeCircuitFormA.employeeName'));
            dispatch(actions.reset('wirelineUpgradeCircuitFormA.wireLineApproverId'));
            dispatch(actions.reset('wirelineUpgradeCircuitFormA'));
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            dispatch({ type: setSubscriptionDetails, data: {} });           
            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }

    }
    , setPlanDetailsModel: (planDetailsModel) => (dispatch) => {
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', planDetailsModel));
    },
    onUpdateForm: () => async (dispatch, state) => {

        const { selectedItem, requestData } = state().requestDetail;
        const { subscriptionList, employeeList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { countryName } = state().wirelineChangeVendorRequest;

        await updateSubscriptionSelect(requestData.Circuit.CircuitCode, subscriptionList, dispatch, state);
        await updateOnEmployeeSelect(
            (requestData?.WireLineApprover?.LastName || '') + ", " + (requestData?.WireLineApprover?.FirstName || ''), 
            employeeList, 
            dispatch, 
            state
        );
        dispatch(actions.change('wirelineUpgradeCircuitFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitCode', requestData.Circuit.CircuitCode));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitId', requestData.CircuitId));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.newPlanId', requestData.Subscription.PlanId));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planName', requestData.Subscription.PlanDetails.PlanName));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', requestData.Subscription.PlanDetails));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planComponentList', requestData.Subscription.PlanDetails.PlanComponents));
        await getPlanDetails(dispatch, requestData.Subscription.PlanId);
        let vendor = await getVendorDetails(dispatch, requestData.Subscription);

        if (vendor) {
            updatePlanTypesByCircuitType(dispatch, setPlanOptions, requestData.Subscription.VendorDetailId, requestData.Circuit.CircuitTypeId);
        }
        
    }
}
    async function updateSubscriptionSelect(circuitCode, subscriptionList, dispatch, state) {

        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { countryName } = state().wirelineChangeVendorRequest;

        let countrySelected = countryName;

        if (isRequestOnBehalf) {
            countrySelected = requestOnBehalfData.Country;
        }

        var obj = subscriptionList.find(o => o["CircuitCode"] === circuitCode);

        dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitCode', circuitCode));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitId', obj?.CircuitId));
        dispatch({ type: setSubscriptionDetails, data: obj });
    }
    async function updateOnEmployeeSelect(value, employeeList, dispatch, state) {
        const obj = employeeList?.find(o => o.LastFirstName === value);

        if (obj != null) {
            dispatch(actions.change('wirelineUpgradeCircuitFormA.employeeName', obj.Name || value));
            dispatch(actions.change('wirelineUpgradeCircuitFormA.wireLineApproverId', obj.EmployeeId));
            dispatch(onSelectedApprover(value, obj.EmployeeId));
            dispatch({ type: setResetApprover, data: false });
        }
    }
async function getPlanDetails(dispatch, planId) {
    dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', []));
    var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + planId);
    if (res != null) {
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planComponentList', res.datatable));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', res.datatable[0]?.dataItem));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planName', res.datatable[0]?.dataItem[0]?.PlanName));
        dispatch({
                type: setPlanDetails,
                data: res.datatable[0].dataItem[0]
            });
    } else {
        dispatch({ type: setPlanDetails, data: planDetailConst });
    }
}

async function getVendorDetails(dispatch, subscription) {

    var data = {
        VendorDetailId: subscription.VendorDetailId,
        CircuitTypeId: subscription.CircuitTypeId,
    };

    var res = await httpPost('external/orderRequest/getVendorDetails', data);

    if (res != null) {
        dispatch({ type: setVendorDetails, data: res });
    } else {
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    }

    return res;
}


function resetWirelineUpgradeCircuitForm(dispatch) {
    dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setPlanDetails, data: planDetailConst });
    dispatch({ type: setFormSubmitted, data: false });
}

function resetWirelineUpgradeCircuitModel(dispatch) {
    dispatch(actions.reset('wirelineUpgradeCircuitFormA'));
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: { ...action.data }
            };
        case setPlanDetails:
            return {
                ...state,
                planDetails: action.data
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            };
        case setResetApprover:
            return {
                ...state
                , isResetApprover: action.data
            }

        default: return state;
    }
}